import type { DeploymentStatus } from './api'

/** Colores de estado, idénticos en toda la aplicación. */
export const STATUS_STYLE: Record<DeploymentStatus, { label: string; dot: string; text: string; bg: string }> = {
  RUNNING:   { label: 'Corriendo',    dot: 'bg-green-500',  text: 'text-green-400',  bg: 'bg-green-500/10' },
  STARTING:  { label: 'Arrancando',   dot: 'bg-blue-500 animate-pulse',   text: 'text-blue-400',   bg: 'bg-blue-500/10' },
  STOPPING:  { label: 'Parando',      dot: 'bg-amber-500 animate-pulse',  text: 'text-amber-400',  bg: 'bg-amber-500/10' },
  STOPPED:   { label: 'Parada',       dot: 'bg-slate-500',  text: 'text-slate-400',  bg: 'bg-slate-500/10' },
  CRASHED:   { label: 'Caída',        dot: 'bg-red-500',    text: 'text-red-400',    bg: 'bg-red-500/10' },
  DEPLOYING: { label: 'Desplegando',  dot: 'bg-blue-500 animate-pulse',   text: 'text-blue-400',   bg: 'bg-blue-500/10' },
  UPDATING:  { label: 'Actualizando', dot: 'bg-blue-500 animate-pulse',   text: 'text-blue-400',   bg: 'bg-blue-500/10' },
  UNHEALTHY: { label: 'Con problemas',dot: 'bg-amber-500',  text: 'text-amber-400',  bg: 'bg-amber-500/10' },
}

export const ENV_LABEL: Record<string, string> = {
  PRODUCTION: 'producción',
  STAGING: 'staging',
  DEVELOPMENT: 'desarrollo',
  PREVIEW: 'preview',
}

export function formatBytes(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined) return '—'
  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  let value = bytes
  let i = 0
  while (value >= 1024 && i < units.length - 1) {
    value /= 1024
    i++
  }
  return `${value.toFixed(value >= 100 || i === 0 ? 0 : 1)} ${units[i]}`
}

export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return '—'
  const diff = Date.now() - new Date(iso).getTime()
  const min = Math.floor(diff / 60000)
  if (min < 1) return 'recién'
  if (min < 60) return `hace ${min} min`
  const h = Math.floor(min / 60)
  if (h < 24) return `hace ${h} h`
  const d = Math.floor(h / 24)
  if (d < 30) return `hace ${d} d`
  return new Date(iso).toLocaleDateString('es-PY')
}

export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString('es-PY', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  })
}
